import { render, staticRenderFns } from "./DYNAMIC_SPECIFIC_FIELD.vue?vue&type=template&id=55fc2c3c&"
import script from "./DYNAMIC_SPECIFIC_FIELD.vue?vue&type=script&lang=js&"
export * from "./DYNAMIC_SPECIFIC_FIELD.vue?vue&type=script&lang=js&"
import style0 from "./DYNAMIC_SPECIFIC_FIELD.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('55fc2c3c', component.options)
    } else {
      api.reload('55fc2c3c', component.options)
    }
    module.hot.accept("./DYNAMIC_SPECIFIC_FIELD.vue?vue&type=template&id=55fc2c3c&", function () {
      api.rerender('55fc2c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/request/extend/DYNAMIC_SPECIFIC_FIELD.vue"
export default component.exports